import {rpAppLink} from "@pg-mono/rp-routes";

import {rpCommonUrl} from "../../../app/read_rp_environment_variables";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {RcnPriceStatsSeriesPoint} from "../types/RcnPriceStatsSeriesPoint";
import {getRcnPointTemporalCoverage} from "../utils/format_rcn_period_label";

interface Props {
    region: IRegionReportPrice;
    offerPriceM2: number | null;
    transactionalPriceM2: number | null;
    lastRcnPeriod: RcnPriceStatsSeriesPoint | undefined;
}

export const PricesRegionSchemaDataset = (props: Props) => {
    const {region, offerPriceM2, transactionalPriceM2, lastRcnPeriod} = props;

    // No RCN point for this city/filter combination - nothing concrete to describe yet.
    if (!lastRcnPeriod || offerPriceM2 === null || transactionalPriceM2 === null) {
        return null;
    }

    const schema = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        name: `Ceny mieszkań ${region.name_declension_where} – ceny ofertowe i transakcyjne`,
        description: `Zestawienie ceny ofertowej z bazy RynekPierwotny.pl i ceny transakcyjnej z aktów notarialnych (Rejestr Cen Nieruchomości) mieszkań na rynku pierwotnym ${region.name_declension_where}.`,
        url: `${rpCommonUrl}${rpAppLink.prices.flats.city({regionSlug: region.slug})}`,
        inLanguage: "pl-PL",
        isAccessibleForFree: true,
        creator: {
            "@type": "Organization",
            name: "RynekPierwotny.pl",
            url: rpCommonUrl
        },
        isBasedOn: {
            "@type": "Dataset",
            name: "Rejestr Cen Nieruchomości",
            description: "Akty notarialne rejestrowane przez starostwa powiatowe"
        },
        spatialCoverage: {
            "@type": "City",
            name: region.short_name
        },
        temporalCoverage: getRcnPointTemporalCoverage(lastRcnPeriod),
        variableMeasured: [
            {"@type": "PropertyValue", name: "Cena ofertowa za m²", value: Math.round(offerPriceM2), unitText: "PLN/m2"},
            {"@type": "PropertyValue", name: "Cena transakcyjna za m²", value: Math.round(transactionalPriceM2), unitText: "PLN/m2"},
            {"@type": "PropertyValue", name: "Liczba transakcji", value: lastRcnPeriod.n_rows}
        ]
    };

    const json = JSON.stringify(schema).replace(/</g, "\\u003c");

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: json}} />;
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {rpCommonUrl} from "../../../app/read_rp_environment_variables";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {RcnPriceStatsSeriesPoint} from "../types/RcnPriceStatsSeriesPoint";
import {getRcnPointTemporalCoverage} from "../utils/format_rcn_period_label";

interface Props {
    region: IRegionReportPrice;
    offerPriceM2: number | null;
    transactionalPriceM2: number | null;
    lastRcnPeriod: RcnPriceStatsSeriesPoint | undefined;
}

export const PricesRegionSchemaDataset = (props: Props) => {
    const {region, offerPriceM2, transactionalPriceM2, lastRcnPeriod} = props;

    // No RCN point for this city/filter combination - nothing concrete to describe yet.
    if (!lastRcnPeriod || offerPriceM2 === null || transactionalPriceM2 === null) {
        return null;
    }

    const schema = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        name: `Ceny mieszkań ${region.name_declension_where} – ceny ofertowe i transakcyjne`,
        description: `Zestawienie ceny ofertowej z bazy RynekPierwotny.pl i ceny transakcyjnej z aktów notarialnych (Rejestr Cen Nieruchomości) mieszkań na rynku pierwotnym ${region.name_declension_where}.`,
        url: `${rpCommonUrl}${rpAppLink.prices.flats.city({regionSlug: region.slug})}`,
        inLanguage: "pl-PL",
        isAccessibleForFree: true,
        creator: {
            "@type": "Organization",
            name: "RynekPierwotny.pl",
            url: rpCommonUrl
        },
        isBasedOn: {
            "@type": "Dataset",
            name: "Rejestr Cen Nieruchomości",
            description: "Akty notarialne rejestrowane przez starostwa powiatowe"
        },
        spatialCoverage: {
            "@type": "City",
            name: region.short_name
        },
        temporalCoverage: getRcnPointTemporalCoverage(lastRcnPeriod),
        variableMeasured: [
            {"@type": "PropertyValue", name: "Cena ofertowa za m²", value: Math.round(offerPriceM2), unitText: "PLN/m2"},
            {"@type": "PropertyValue", name: "Cena transakcyjna za m²", value: Math.round(transactionalPriceM2), unitText: "PLN/m2"},
            {"@type": "PropertyValue", name: "Liczba transakcji", value: lastRcnPeriod.n_rows}
        ]
    };

    const json = JSON.stringify(schema).replace(/</g, "\\u003c");

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: json}} />;
};
